export function Unsubscribe<T extends { new (...args: Array<any>): {} }>(constructor: T) {
  const original = constructor.prototype.ngOnDestroy;

  constructor.prototype.ngOnDestroy = function (...args: Array<any>) {
    for (let prop in this) {
      const property = this[prop];

      if (property && typeof property.unsubscribe === 'function') {
        property.unsubscribe();
      }
    }

    original && typeof original === 'function' && original.apply(this, args);
  };
}
